import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRippleModule } from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PipesModule } from 'app/pipes/pipes.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { TranslateModule } from '@ngx-translate/core';
import { AgmCoreModule } from '@agm/core';
import { CompanyListComponent } from './company-list/company-list.component';
import { CompanyFormComponent } from './company-form/company-form.component';
import { CompanyService } from 'app/services/company.service';
import { ContractListComponent } from './contract-list/contract-list.component';
import { ContractFormComponent } from './contract-form/contract-form.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RoleMenuFormComponent } from './role/role-menu-form/role-menu-form.component';
import { MatStepperModule } from '@angular/material/stepper';
import { GlobalConfigFormComponent } from './global-config-form/global-config-form.component';
import { CustomFuelInformationListComponent } from './custom-fuelInformation-list/custom-fuelInformation-list.component';
import { CustomFuelInformationFormComponent } from './custom-fuelInformation-form/custom-fuelInformation-form.component';



@NgModule({
    declarations: [
        CompanyListComponent, 
        CompanyFormComponent,
        ContractListComponent,
        ContractFormComponent,
        RoleMenuFormComponent,
        GlobalConfigFormComponent,
        CustomFuelInformationListComponent,
        CustomFuelInformationFormComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        MatTableModule,
        FuseSharedModule,
        FuseSidebarModule,
        MatProgressBarModule,
        FuseWidgetModule,
        MatCardModule,
        MatChipsModule,
        MatExpansionModule,
        MatInputModule,
        MatPaginatorModule,
        MatStepperModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatRippleModule,
        MatSortModule,
        MatTabsModule,
        MatSnackBarModule,
        PipesModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        TranslateModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
        })
    ],
    providers: [CompanyService]
})
export class CompanyModule { }
